import axios from './common/axios';

export default {
  getPaymentPlan(data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/orders/premium/${data.subscriptionId}/payment_plan`)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  switchAutoRenewal(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/orders/premium/${data.subscriptionId}/auto_renewal`, {
          is_auto_renewal: data.is_auto_renewal
        })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  switchAutoRenewalReminder(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/orders/premium/${data.subscriptionId}/auto_renewal_reminder`, {
          value: data.value
        })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  switchPlanOnNextRenewal(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/orders/premium/${data.subscriptionId}/switch_next_plan`, {
          nextPlanSlug: data.nextPlanSlug
        })
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  switchPlanImmediately(data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/premium/fund', data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
  fund(data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/premium/fund', data)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }
};
